import { TableColumnHeader } from "@/components/shared/table/Table";
import { ColumnDef } from "@tanstack/react-table";
import { IntlShape } from "react-intl";
import { TFunction } from "i18next";
import { TrashIcon } from "lucide-react";
import { formatDateLocale, getProvinceNameByCode } from "@/utils/helpers";
import { Button } from "@/components/ui/button";
import { Holiday } from "@/graphql/__generated__/graphql";

export const getColumnsHoliday = (
  intl: IntlShape,
  t: TFunction,
  handleRemoveHoliday: (_holiday: Holiday) => void,
  isConfigAdmin: boolean,
): ColumnDef<Holiday>[] => [
  {
    accessorKey: "date",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:holiday.columns.date")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const date = new Date(row.getValue("date"));
      return <div className="font-medium">{formatDateLocale(intl, date)}</div>;
    },
  },
  {
    accessorKey: "dayOfWeek",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:holiday.columns.dayofweek")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const dateValue = row.getValue("date") as string;
      const date = new Date(dateValue);
      // Use Intl to format localized short weekday
      const dayShort = formatDateLocale(intl, date, { weekday: "short" });
      return <div className="font-medium">{dayShort}</div>;
    },
  },
  {
    accessorKey: "province",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:holiday.columns.province")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const provinceCode = row.getValue("province") as string;
      return <div>{getProvinceNameByCode(provinceCode, true)}</div>;
    },
  },
  ...(isConfigAdmin
    ? [
      {
        accessorKey: "actions",
        size: 60,
        minSize: 60,
        maxSize: 80,
        header: () => <div></div>,
        cell: ({ row }) => (
          <div className="flex gap-2 justify-end">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleRemoveHoliday(row.original)}
            >
              <TrashIcon className="w-4 h-4 text-red-500" />
            </Button>
          </div>
        ),
      },
    ]
    : []),
];
